export default __webpack_public_path__ + "static/media/LAS0880.34I-39655_-23555_0.47348328.jpg";